
import SoundChannel from './SoundChannel';
import { Howler, Howl } from 'howler';
import Cue from '../../UTIL/Instances/Cue';
import LOG, { log } from '../../UTIL/LOG';

class Sounds
{
   // const {Howl, Howler} = require('howler');

   public SFX       : SoundChannel;
   public Voice     : SoundChannel;
   public Music     : SoundChannel;
   public Ambiance  : SoundChannel;

   private channels : any = {};

   public isMuted   : boolean = false;
   public mappings  : any = {};
 
   public isInitialized : boolean = false;
 
   constructor()
   {
      this.SFX              = this.addChannel( "sfx", "sound", true );
      this.Voice            = this.addChannel( "voice", "sound", true );
      this.Music            = this.addChannel( "music", "music", false );
      this.Ambiance         = this.addChannel( "amb", "music", false );
 
      Howler.autoUnlock     = true;
      Howler.html5PoolSize  = 100;
   };

   private addChannel( id:any, b:any, c:any )
   {
      let channel : SoundChannel = this.channels[ id ] = new SoundChannel( this, id, b, c );
      return channel;
   };

   public setVolume( vol:number )
   {
      Howler.volume( vol );

     // if( vol === 0 ) return Howler.mute( true );
     // if( !this.isMuted ) Howler.mute( false );
   }

   public mute()
   {
      this.isMuted = true;
      
   }

   public unmute()
   {
      this.isMuted = false;
      Howler.mute( false );
   }

   public resetMappings()
   {
     this.mappings = {};
   }

   public init( vars?:any )
   {
     this.isInitialized = true;
 
     this.stop();

     this.resetMappings();

     if( !vars ) return;

     for( let key in vars ) this.set( key, vars[ key ] );
   }

   public set( key:string, array:any )
   {
     let cue = this.mappings[ key ] = new Cue( true );
 
     cue.copy( array );
   }

   public get( key:string )
   {
     let cue : Cue = this.mappings[ key ];
     return cue ? cue.get() : key;
   }

   public stop()
   {
      this.SFX.stop();
      this.Voice.stop();
      this.Music.stop();
      this.Ambiance.stop();
   }

 
}

export default Sounds;

